var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInvite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Featured icon",
    filter: "url(#filter0_d_5109_56862)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1,
    width: 48,
    height: 48,
    rx: 10,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 1.5,
    width: 47,
    height: 47,
    rx: 9.5,
    stroke: "#EAECF0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M39.8738 17.6564H36.3087C35.775 17.6564 35.3423 18.0891 35.3423 18.6228C35.3423 19.1565 35.775 19.5893 36.3087 19.5893H38.4081L26.3919 29.8174C26.16 30.015 25.8379 30.014 25.6059 29.8153L13.5919 19.5903H15.6805C16.2142 19.5903 16.647 19.1576 16.647 18.6239C16.647 18.0902 16.2142 17.6574 15.6805 17.6574H12.1262C10.9536 17.6574 10 18.6121 10 19.7836V36.1595C10 37.3385 10.9536 38.2964 12.1262 38.2964H39.8738C41.0464 38.2964 42 37.3374 42 36.1595V19.7836C42 18.611 41.0464 17.6564 39.8738 17.6564ZM40.0671 20.7178V35.2338L31.5399 27.9758L40.0671 20.7178ZM26 31.9007C26.5852 31.9007 27.1694 31.6966 27.6462 31.2897L30.0483 29.2451L38.4102 36.3635H13.5887L21.9506 29.2451L24.3506 31.2875C24.8295 31.6956 25.4148 31.9007 26 31.9007ZM20.4601 27.9748L11.9329 35.2338V20.7178L20.4601 27.9748Z",
    fill: "#535862"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M25.7057 23.6262C25.8012 23.6563 25.9 23.6724 25.9988 23.6724C26.0976 23.6724 26.1975 23.6563 26.293 23.6262C29.3073 22.663 33.8904 19.55 33.3556 15.2976C33.1011 13.2906 31.9296 11.7615 30.2222 11.2096C28.7983 10.7532 27.2498 11.0539 25.9988 11.9978C24.75 11.0549 23.1983 10.7532 21.7765 11.2106C20.0681 11.7615 18.8965 13.2906 18.642 15.2976C18.104 19.5532 22.6882 22.6641 25.7057 23.6262ZM20.561 15.5414C20.7199 14.2775 21.3803 13.3701 22.3714 13.0501C22.613 12.9717 22.8632 12.9341 23.1134 12.9341C23.8866 12.9341 24.6759 13.2939 25.2933 13.9553C25.4748 14.1508 25.7304 14.2614 25.9988 14.2614C26.2673 14.2614 26.5228 14.1497 26.7054 13.9543C27.5236 13.077 28.6447 12.729 29.6273 13.049C30.6173 13.369 31.2777 14.2775 31.4377 15.5392C31.7932 18.357 28.562 20.7666 25.9988 21.6847C23.4345 20.7688 20.2034 18.3602 20.561 15.5414Z",
    fill: "#85242D"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5109_56862",
    x: 0,
    y: 0,
    width: 52,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5109_56862"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5109_56862",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvite);
export default __webpack_public_path__ + "static/media/invite.28ac23151b400b55615f4316e08eeb96.svg";
export { ForwardRef as ReactComponent };